const reporting = {
  id: "reporting",
  title: "Post-Event Reporting & Measurable Outcomes",
  questions: [
    {
      question: "Do you provide a post-event report after completion?",
      answer: "Yes. We share a structured summary covering execution highlights, attendance data, and key observations."
    },
    {
      question: "What does the post-event report typically include?",
      answer: "Guest participation details, budget reconciliation, vendor performance notes, and overall execution analysis."
    },
    {
      question: "Can you measure guest engagement levels?",
      answer: "Yes. Through attendance tracking, activity participation data, and structured feedback collection."
    },
    {
      question: "Do you collect feedback from participants?",
      answer: "We provide digital or on-ground feedback mechanisms to capture participant experience insights."
    },
    {
      question: "How do you evaluate event success?",
      answer: "Success is assessed against predefined objectives such as engagement, turnout, schedule adherence, and brand visibility."
    },
    {
      question: "Will we receive final financial reconciliation documents?",
      answer: "Yes. A detailed expense summary is shared for internal accounting and audit reference."
    },
    {
      question: "Can you provide event photo and video documentation?",
      answer: "Yes. Professionally captured and edited media assets are delivered post-event."
    },
    {
      question: "Do you offer insights for future event improvements?",
      answer: "We include strategic observations and recommendations for better planning in future editions."
    },
    {
      question: "Can post-event data support internal reporting to leadership?",
      answer: "Absolutely. Our summary reports are formatted for easy internal presentation and decision-making use."
    },
    {
      question: "How quickly is the post-event report delivered?",
      answer: "Typically within 5–7 working days after completion, depending on event scale."
    }
  ]
};

export default reporting;
